import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

export default function MostPopularPlanLabel() {
  const { t } = useTranslation();

  return (
    <Typography
      sx={(theme) => ({
        position: 'absolute',
        top: 0,
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: theme.palette.primary.main,
        fontWeight: 500,
        fontSize: '14px',
        color: 'white',
        p: '4px 12px',
        borderRadius: '14px',
        whiteSpace: 'nowrap',
      })}
    >
      {t('plans.most-popular')}
    </Typography>
  );
}
